import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triangle-up",
  "use": "icon-triangle-up-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-triangle-up\">\n<path d=\"M186,139.7l-81.2-94.8c-2.4-2.8-7.1-2.8-9.5,0L14,139.7c-1.6,1.9-2,4.5-0.9,6.7c1,2.2,3.2,3.6,5.7,3.6h162.5\n\tc2.4,0,4.7-1.4,5.7-3.6C187.9,144.1,187.6,141.5,186,139.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol